import React from 'react';

export default function LoadMoreButton({ type, edit }) {
  return (
    <a id="load-more-cards" className="btn btn-load-more" onClick={edit}>
      {type === 'loadMore' ? 'Load More' : 'See Less'}
    </a>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Trek/DayTrail/LoadMoreButton.js